import texts from './mcactionbutton.texts'

class McactionbuttonController {
    constructor($scope, config, SharedMoments, Share) {
        this.name = 'mcactionbutton'

        this.$scope = $scope

        this.config = config
        this.SharedMoments = SharedMoments
        this.ShareFactory = Share
    }

    $onInit() {
        this.render()

        this.watchLanguage()

        this.thumbed = this.alreadyThumbed()
    }

    render() {
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        const {
            SHARE
        } = texts[this.language]

        this.shareText = SHARE
    }

    alreadyThumbed() {
        const localStorageThumbs = JSON.parse(localStorage.getItem('tourists_thumbs'))

        return localStorageThumbs && localStorageThumbs.includes(this.url)
    }

    sharePost() {
        this.ShareFactory.shareObject(`${this.config.frontUrl}/post?id=${this.id}`)
    }

    saveThumb(url) {
        if (this.isThumbLoading) {
            return
        }

        this.isThumbLoading = true

        let thumbsLocalStorage = JSON.parse(localStorage.getItem('tourists_thumbs'))

        // if is not alredy thumbed
        if (!this.thumbed) {
            this.SharedMoments.thumbPost(url, 'UP')
                .then(() => {
                    // Change thumb icon
                    this.thumbed = true

                    // Add thumbs
                    this.thumbs = parseInt(this.thumbs) + 1

                    // Save to local storage
                    if (!thumbsLocalStorage) {
                        thumbsLocalStorage = new Array()
                        localStorage.setItem('tourists_thumbs', JSON.stringify(thumbsLocalStorage))
                    }
                    thumbsLocalStorage.push(this.url)
                    localStorage.setItem('tourists_thumbs', JSON.stringify(thumbsLocalStorage))

                    this.isThumbLoading = false
                })
                .catch((err) => {
                    console.log('Error occured in method thumbPost', err)

                    this.error = err.data

                    this.isThumbLoading = false
                })
        } else { // Unthumb
            this.SharedMoments.thumbPost(url, 'DOWN')
                .then(() => {
                    let urlIndex = thumbsLocalStorage.indexOf(this.url)
                    if (urlIndex != -1) {
                        thumbsLocalStorage.splice(urlIndex, 1)

                        localStorage.setItem('tourists_thumbs', JSON.stringify(thumbsLocalStorage))

                        this.thumbed = false

                        // Subtract thumbs
                        this.thumbs = parseInt(this.thumbs) - 1
                        this.thumbs = this.thumbs < 0 ? 0 : this.thumbs
                    }

                    this.isThumbLoading = false
                })
                .catch((err) => {
                    console.log('Error occured in method thumbPost', err)

                    this.error = err.data

                    this.isThumbLoading = false
                })
        }
    }

    watchLanguage() {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.render()
            }
        })
    }
}

McactionbuttonController.$inject = ['$scope', 'config', 'SharedMoments', 'Share']

export default McactionbuttonController



// WEBPACK FOOTER //
// ./client/app/common/mcactionbutton/mcactionbutton.controller.js